import type { CategoryType } from "@/components/resources/data/posts.types"

export interface ResourceCategory {
  /** Short name for navigation and tags */
  name: string
  /** Singular name shown on the post page */
  categoryName: string
  /** Page heading */
  title: string
  lead: string
  /** Falls back to `lead` */
  metaDescription?: string
}

// Keyed by slug: posts live in content/resources/{slug}/.
export const RESOURCE_CATEGORIES = {
  articles: {
    name: "News",
    categoryName: "News",
    title: "News",
    lead: "News, articles and announcements from the Token Terminal team",
  },
  "crypto-research": {
    name: "Research",
    categoryName: "Research",
    title: "Crypto research",
    lead: "Data-driven analysis on blockchains, decentralized applications, and market segments",
  },
  interview: {
    name: "Interviews",
    categoryName: "Interview",
    title: "Project interviews",
    lead: "Interviews with core contributors in crypto to gain insights into their day-to-day operations",
  },
  "weekly-fundamentals": {
    name: "Newsletters",
    categoryName: "Newsletter",
    title: "Weekly fundamentals",
    lead: "A weekly walkthrough of the most interesting charts and trends in crypto",
  },
  changelog: {
    name: "Changelog",
    categoryName: "Changelog",
    title: "Changelog",
    lead: "Updates and improvements to the Terminal platform.",
  },
  community: {
    name: "Community",
    categoryName: "Community",
    title: "Community",
    lead: "Community content from external contributors.",
  },
  engineering: {
    name: "Engineering",
    categoryName: "Engineering",
    title: "Engineering",
    lead: "Technical posts from the Token Terminal engineering team",
    metaDescription:
      "Technical posts from the Token Terminal engineering team — architecture decisions, data pipeline design, and lessons from building institutional-grade onchain analytics.",
  },
} as const satisfies Partial<Record<CategoryType, ResourceCategory>>

export type ResourceCategorySlug = keyof typeof RESOURCE_CATEGORIES

export const isResourceCategory = (
  slug: string
): slug is ResourceCategorySlug => Object.hasOwn(RESOURCE_CATEGORIES, slug)
